<script setup lang="ts">
/**
 * The document-scoped grade selector, rendered in the editor header beside Save — it governs the
 * whole document, so it belongs with the document-level actions. Rules in `grade-select.hook.ts`.
 */
import { AppSelect } from '@shared/ui/selects'

import { useGradeSelect } from '../../../model/assessments/grade-select.hook'

defineOptions({
  name: 'GradeSelect',
})

const {
  refGrade,
  gradeSelectOptions,
} = useGradeSelect()
</script>

<template>
  <div class="grade-select">
    <AppSelect
      v-model="refGrade"
      :options="gradeSelectOptions"
      placeholder="Select grade"
      required
    />
  </div>
</template>

<style scoped lang="scss" src="./GradeSelect.scss" />
